import { Button, Flex, Text, useToast } from '@chakra-ui/react';
import { useState } from 'react';

import { usePasswordRecovery } from '../../contexts/PasswordRecoveryContext';

import { forgotPassword } from '@/api';
import { Link } from '@/components/common/Link';
import { FieldWrapper, Form, TextInput } from '@/components/Form';
import { v } from '@/lib/validator';

type ForgotPasswordBody = {
  email: string;
};

const forgotPasswordSchema = v.object({
  email: v.string().email('Formato de email inválido').required('Campo é obrigatório'),
});

export const SendCodeStep = () => {
  const { dispatch } = usePasswordRecovery();
  const toast = useToast();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: ForgotPasswordBody) => {
    setLoading(true);
    try {
      await forgotPassword({ body: values });
      toast({
        title: 'Código de recuperação enviado',
        description: 'Verifique seu email para recuperar o código',
        status: 'success',
        duration: 3000,
      });
      dispatch({ type: 'NEXT_STEP', payload: { email: values.email } });
    } catch (err) {
      toast({
        title: 'Erro ao solicitar código de recuperação de senha',
        description: 'Verifique se o email está correto e tente novamente',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Flex direction="column" gap="8" w="full">
      <Flex direction="column" w="full">
        <Text color="primary.500" fontWeight="bold" fontSize="lg">
          Recuperação de Senha
        </Text>
        <Text>Insira o email da conta que deseja recuperar</Text>
      </Flex>

      <Form<ForgotPasswordBody>
        initialValues={{
          email: '',
        }}
        onSubmit={handleSubmit}
        validationSchema={forgotPasswordSchema}
      >
        {() => (
          <Flex direction="column" gap="8">
            <FieldWrapper
              name="email"
              required
              label="Email"
              as={(props) => <TextInput type="email" {...props} />}
            />

            <Flex gap="2" w="full" alignSelf="center">
              <Button type="button" as={Link} to="/login" w="100%">
                Cancelar
              </Button>
              <Button isLoading={loading} type="submit" variant="@primary" w="100%">
                Enviar
              </Button>
            </Flex>
          </Flex>
        )}
      </Form>
    </Flex>
  );
};
